import { render, staticRenderFns } from "./installationsDetailsView.vue?vue&type=template&id=24fc2c5c&"
import script from "./installationsDetailsView.vue?vue&type=script&lang=js&"
export * from "./installationsDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./installationsDetailsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports